export default __webpack_public_path__ + "static/media/caseHistory.b5067ec2.svg";